export default "__VITE_ASSET__Dd98z1z$__"